import { ISelectOption } from "./selectOption.interface";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { beautifyCamelCaseString } from "src/app/common/stringUtils";
import { StepType } from "../api/agentStep.model";

const allStepTypes = (Array.from(Object.keys(StepType)) as (keyof typeof StepType)[]).map((stepTypeStr) => StepType[stepTypeStr]);

export const StepTypeSelectOptions: ISelectOption[] = allStepTypes.sort().map((stepType: StepType) => ({
    id: `${FilterTypesEnum.StepType}-${stepType}`,
    value: stepType,
    displayName: beautifyCamelCaseString(stepType),
    categoryName: FilterTypesEnum.StepType.toString(),
    filterType: FilterTypesEnum.StepType,
    withoutBeautifyDisplayName: true,
}));
